import "../polyfills";
import { createRoot } from "react-dom/client";
import tippy from "tippy.js";
import { initI18n } from "@/i18n";
import { App } from "@/interface/App";
import "@/canv/styles";

tippy.setDefaultProps({
    delay: 250,
    arrow: false,
    theme: "barPanelTooltip",
});

function startJespo(boardData) {
    initI18n(boardData);

    const rootEl = document.createElement("div");
    rootEl.setAttribute("id", "react-root");
    document.body.appendChild(rootEl);

    const root = createRoot(rootEl);

    root.render(<App boardData={boardData} />);
}

window["startJespo"] = startJespo;
